export default "__VITE_ASSET__zhDHyMby__"